import HairColor from './HairColor';

export default HairColor;
